module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"filters":"Фильтры:"},"en":{"filters":"Filters:"}}')
  delete Component.options._Ctor
}
